/* istanbul ignore next */
import { createUseStyles } from '@glu/theming';

const styles = ({
  palette: { grey },
  spacing: { unit },
  typography: { fontWeightHeavy, title }
}) => ({
  modalWrapper: {
    padding: unit * 2
  },
  capitalize: {
    textTransform: 'uppercase'
  },
  bold: {
    fontWeight: fontWeightHeavy
  },
  inputSection: {
    padding: `${unit * 2}px 0 0 0 `,
    textAlign: 'left',
    display: 'flex'
  },
  inputField: {
    width: '75%',
    '& .form-group': {
      minHeight: 11.5 * unit
    }
  },
  resendLink: {
    margin: `${unit * 4}px 0 0 ${unit * 2}px`,
    '& button': {
      fontSize: title.fontSize
    }
  },
  lowerCase: {
    textTransform: 'lowercase'
  },
  altWay: {
    textAlign: 'left',
    padding: `${unit}px 0 ${unit * 3}px 0`,
    '& button': {
      fontSize: title.fontSize
    }
  },
  error: {
    color: 'red',
    fontSize: '12px',
    paddingBottom: '30px'
  },
  hide: {
    display: 'none'
  },
  show: {
    display: 'block'
  },
  rememberMe: {
    textAlign: 'left',
    '& div': {
      marginRight: unit
    },
    '& span': {
      color: grey.G600
    }
  },
  centerContent: {
    justifyContent: 'center'
  }
});
export default createUseStyles(styles);
